export enum QueryKeys {
  //Shares
  tenderRegistration = 'tenderRegistration',
  sharedTender = 'sharedTender',
  tenderAdminSharedTender = 'tenderAdminSharedTender',
  secondaryShareKeys = 'secondaryShareKeys',
  adminSecondaryShareKeys = 'adminSecondaryShareKeys',
  tenderShareCoreFolders = 'tenderShareCoreFolders',
  publicTender = 'publicTender',
  publicTenders = 'publicTenders',

  //Files
  tenderTenderFoldersVersionedFiles = 'tenderTenderFoldersVersionedFiles',
  tendersTenderAttachments = 'tendersTenderAttachments',

  draftOrderVoucher = 'draftOrderVoucher',
  orderVoucher = 'orderVoucher',
  offers = 'offers',
  question = 'question',
  coreTenderRegistration = 'coreTenderRegistration',
  questionsChangeLog = 'questionsChangeLog',
  sharedTenderDetails = 'sharedTenderDetails',
  sharedTenderQuestion = 'sharedTenderQuestion',
  sharedTenderMyQuestion = 'sharedTenderMyQuestion',
  sharedContractOffer = 'sharedContractOffer',
  questionsPendingCount = 'questionsPendingCount',
}
